import { render, staticRenderFns } from "./VNavBar.vue?vue&type=template&id=afe1e3e6&"
import script from "./VNavBar.vue?vue&type=script&lang=js&"
export * from "./VNavBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports